import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const WorkProposalCalls = () => {
  const submitButton = {
    title: "Workshop Proposal",
    url: "https://advance-crt.ie",
  };

  const profilesWorkshop = [
    {
      title: "Dr",
      firstName: "Susan",
      surname: "Rea",
      university: "Munster Technological University",
      bio: "https://www.nimbus.cit.ie/researchers/dr-susan-rea/",
      image: "./images/profiles/SusanR.png",
      linkedin:
        "https://www.linkedin.com/in/susan-rea-nimbus-mtu/?originalSubdomain=ie",
      twitter: null,
      email: "susan.rea@mtu.ie",
    },
    {
      title: "Prof",
      firstName: "Jin",
      surname: "Nakazawa",
      university: "Keio University, Japan",
      bio: "https://www.sfc.keio.ac.jp/faculty_profile/en/list/EI/jin-nakazawa.html",
      image: "./images/profiles/jin.jpg",
      linkedin: "https://www.linkedin.com/in/jin-nakazawa-a5b8b25b/",
      email: "jin@sfc.keio.ac.jp",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>Call for Workshop Proposals </h2>
        <p>
          The organising committee of the IEEE International Conference on Smart
          Computing (SMARTCOMP) 2025 invites proposals for workshops to be held
          in conjunction with the main conference in Cork, Ireland from on June
          16th, 2025. SMARTCOMP is the premier forum for exploring cutting-edge
          research, innovation, and applications in the rapidly evolving domain
          of smart computing, encompassing advancements in sensor-based
          technologies, IoT, cyber-physical systems, edge and cloud computing,
          big data, machine learning, and AI.
        </p>
        <p>
          The workshops at SMARTCOMP 2025 aim to encourage researchers,
          practitioners, and industry experts to exchange ideas, discuss
          emerging trends, and explore novel approaches within the field of
          smart computing.
        </p>
        <p>
          The Workshops co-chairs of SMARTCOMP 2025 invite proposals for half or
          full day workshops affiliated with the conference. Workshops should
          provide opportunities for deep dives into focused areas, promote
          lively interactions, and stimulate collaborative research in both
          emerging and established topics.
        </p>
        <h3>Submission Guidelines</h3>
        <p>Each workshop proposal must include the following: </p>
        <ol>
          <li>
            <span style={{ fontWeight: "bold" }}>Workshop Title</span> and
            Acronym, where applicable.
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Organisers:</span> Names,
            affiliations, and short bios of up to 200 words for each organizer;
            workshops may have up to three organizers. It is strongly
            recommended that organisers belong to at least two different
            institutions.
          </li>
          <li>A brief description (up to 2 pages) including:</li>
          <ul>
            <li>the technical issues that the workshop will address,</li>
            <li>
              the reasons the workshop is of interest to the SMARTCOMP
              community,
            </li>
            <li>
              a short discussion on other available workshops and conferences on
              similar topics and an outline of why the proposed workshop is
              unique;
            </li>
            <li>
              a description of the community groups the workshop aims to
              attract,
            </li>
            <li>the names of potential Program Committee members;</li>
            <li>
              the planned format of the workshop (e.g., keynotes, paper
              presentations, posters, demos) and duration (e.g., one-day,
              half-day), including a strategy to facilitate lively discussions
              and involvement of the attendees;
            </li>
            <li>
              if applicable, a description of past versions of the workshop,
              including dates, organizers, number of submitted and accepted
              papers, and number of attendees;
            </li>
            <li>
              if the workshop is going to be organized for the first time, an
              estimate of the expected number of submissions and attendees;
            </li>
            <li>a tentative Call for Papers (as complete as possible);</li>
            <li>
              a description of the plans for publicity and workshop Website.
            </li>
          </ul>
        </ol>
        <h3>Submission Method</h3>
        <p>
          Workshop proposals should be submitted in PDF format by email with the
          subject line “SMARTCOMP 2025 Workshop Proposal” to all Workshop
          Co-Chairs: Jin Nakazawa (
          <a href="mailto:jin@sfc.keio.ac.jp">jin@sfc.keio.ac.jp</a>) and Susan
          Rea (<a href="mailto:susan.rea@mtu.ie">susan.rea@mtu.ie</a>) no later
          than Friday, 6 December 2024. More details on IEEE SMARTCOMP 2025 can
          be found at our home page{" "}
          <a href="https://www.cs.ucc.ie/smartcomp2025/"> here</a>.
        </p>
        <h3>Important Dates</h3>
        <p>
          Workshop Proposal Submission Deadline:
          <span style={{ fontWeight: "bold" }}> Friday, 6 December 2024</span>
        </p>
        <p>
          Notification of Acceptance:
          <span style={{ fontWeight: "bold" }}> Monday, 16 December 2024</span>
        </p>
        <p>
          Workshop Paper Submission Deadline:
          <span style={{ fontWeight: "bold" }}> TBD</span>
        </p>
        <p>
          Workshop Date:
          <span style={{ fontWeight: "bold" }}> Monday, 16 June 2025</span>
        </p>
        <h3>Publication</h3>
        <p>
          Each accepted paper will require a full SMARTCOMP registration (no
          registration is available for workshops only) and in-person
          presentation. All accepted papers presented in the workshop will be
          published in the proceedings of the conference and published in the
          IEEE Xplore Digital Library and Scopus indexed. Papers that are not
          presented at the workshop will not be published in the proceedings.
        </p>
        <h3>SMARTCOMP 2025 Workshop Co-Chairs</h3>
        <div>
          {profilesWorkshop.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
      </div>
    </div>
  );
};
